import AnimalShelters from "../../components/ClassTwo/EnvironmentScience/AnimalShelters";
import Celebrations from "../../components/ClassTwo/EnvironmentScience/Celebrations";
import ClothsToWear from "../../components/ClassTwo/EnvironmentScience/ClothsToWear";
import Communication from "../../components/ClassTwo/EnvironmentScience/Communication";
import DailyRoutine from "../../components/ClassTwo/EnvironmentScience/DailyRoutine";
import DifferentHouse from "../../components/ClassTwo/EnvironmentScience/DifferentHouse";
import Festivals from "../../components/ClassTwo/EnvironmentScience/Festivals";
import FoodWater from "../../components/ClassTwo/EnvironmentScience/FoodWater";
import GrowingUp from "../../components/ClassTwo/EnvironmentScience/GrowingUp";
import NaturalManmade from "../../components/ClassTwo/EnvironmentScience/NaturalManmade";
import Neighbours from "../../components/ClassTwo/EnvironmentScience/Neighbours";
import SenseOrgan from "../../components/ClassTwo/EnvironmentScience/SenseOrgan";
import SunMoonStar from "../../components/ClassTwo/EnvironmentScience/SunMoonStar";
import TheEarth from "../../components/ClassTwo/EnvironmentScience/TheEarth";
import WeatherSeason from "../../components/ClassTwo/EnvironmentScience/WeatherSeason";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/environmental-science/growing-up", title: "Growing Up", component: GrowingUp },
    { url: "/class-two/environmental-science/our-sense-organs", title: "Our Sense Organs", component: SenseOrgan },
    { url: "/class-two/environmental-science/food-and-water", title: "Food and Water", component: FoodWater },
    { url: "/class-two/environmental-science/cloths-to-wear", title: "Clothes to Wear", component: ClothsToWear },
    { url: "/class-two/environmental-science/different-house", title: "Different House", component: DifferentHouse },
    { url: "/class-two/environmental-science/daily-routine", title: "Our Daily Routine", component: DailyRoutine },
    { url: "/class-two/environmental-science/celebration-with-family", title: "Celebrations with Family", component: Celebrations },
    { url: "/class-two/environmental-science/festivals-we-celebrate", title: "Festivals We Celebrate", component: Festivals },
    { url: "/class-two/environmental-science/our-neighbours", title: "Our Neighbours", component: Neighbours },
    { url: "/class-two/environmental-science/animals-shelters", title: "Animals and their Shelters", component: AnimalShelters },
    { url: "/class-two/environmental-science/natual-manmade-things", title: "Natural Man-made Things", component: NaturalManmade },
    { url: "/class-two/environmental-science/weather-seasons", title: "Weather and Seasons", component: WeatherSeason },
    { url: "/class-two/environmental-science/communications", title: "Means of Communication", component: Communication },
    { url: "/class-two/environmental-science/the-earth", title: "The Earth", component: TheEarth },
    { url: "/class-two/environmental-science/sun-moon-stars", title: "The Sun, the Moon and the Stars", component: SunMoonStar },
];


export default topics;